import { observer } from 'mobx-react-lite';
import React from 'react';

import { List, ListItem } from '@feathr/components';
import BillableCard from '@feathr/extender/components/BillableCard';
import { StoresContext } from '@feathr/extender/state';

function BillableList() {
  const { Billables } = React.useContext(StoresContext);
  const billables = Billables.list();

  return (
    <List>
      {billables.isPending && <ListItem key={'pending'}>...</ListItem>}
      {billables.models.map((billable) => (
        <ListItem key={billable.get('id')}>
          <BillableCard allowDelete={true} billable={billable} />
        </ListItem>
      ))}
    </List>
  );
}

export default observer(BillableList);
